import { AsynchronousRequisitesProps } from "../../types/common";
import AsynchronousRequisites from "./Asynchronous/AsynchronousRequisites";

export const InnSelect = ({
    onChange,
    value,
    field,
    error,
    callbackResult,
    id,
}: Omit<AsynchronousRequisitesProps, "onChange" | "label" | "getParam"> & { onChange: (value: string) => void }) => {
    return (
        <AsynchronousRequisites
            onChange={item => {
                onChange(item?.requisites?.inn ?? "");
            }}
            getParam="inn"
            value={value}
            label={"ИНН"}
            error={error}
            callbackResult={callbackResult}
            id={id}
        />
    );
};
